function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ServiceFactory from "../../service";
import { runAgent, waitAgent, runIdOf } from "./agent-run";
import { searchProducts } from "./images-api";
import { AssetPicker } from "./sequence-create";

// New story (DS 2026-10-02, product launch use case; one-page layout 2026-10-08, mockup storyflow/NewStory): a story
// from scratch with no copy to repurpose. Only the title is required; everything in the side panel can be added later.
// Facts come from what you type, pages you point at (imported as source blocks) and screenshots you upload or
// have captured from public URLs. Every screenshot gets a vision description written onto the story as a source
// block, so the planner and writers can describe what the product does from what it looks like.

function svc(api) {
  const S = ServiceFactory.getType(api, "product");
  return new S();
}
async function safe(p) {
  try {
    return await p;
  } catch (e) {
    return null;
  }
}
const toast = m => {
  const t = document.querySelector("paper-toast");
  if (t && m) t.show(m);
};
// Goal values the Builder understands (?goal= picks the matching starting setup on the Brief); plain labels only.
const GOALS = [["launch", "Launch something new"], ["sell_down", "Run a sale or offer"], ["seasonal", "Seasonal"], ["awareness", "Get the word out"], ["other", "Something else"]];
export class CreateStorySheet extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      title: "",
      product: "",
      summary: "",
      goal: "launch",
      goalText: "",
      pages: [],
      pageDraft: "",
      pageOpen: false,
      capture: true,
      files: [],
      busy: "",
      step: "",
      log: [],
      prodQ: "",
      prodHits: [],
      products: [],
      prodOpen: false,
      offerOpen: false,
      offer: {
        dates: "",
        price: "",
        code: "",
        link: ""
      },
      docs: [],
      pieceQ: "",
      pieces: [],
      library: null,
      media: [],
      mediaPick: null,
      mediaAll: []
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "note", m => {
      if (this._alive) this.setState({
        step: m,
        log: [...this.state.log, m]
      });
    });
    _defineProperty(this, "addPages", () => {
      this.setState({
        pages: this.urlList(),
        pageDraft: ""
      });
    });
    _defineProperty(this, "uploadOne", async f => {
      const pre = await svc("/content/assets/upload-url").postAsync({
        fileName: f.name,
        contentType: f.type || "application/octet-stream",
        bytes: f.size
      });
      if (!pre || !pre.uploadUrl) throw new Error("Could not prepare the upload.");
      const put = await fetch(pre.uploadUrl, {
        method: "PUT",
        headers: {
          "content-type": pre.contentType || f.type || "application/octet-stream"
        },
        body: f
      });
      if (!put.ok) throw new Error(`Upload failed (${put.status})`);
      return svc("/content/assets").postAsync({
        kind: pre.kind || "image",
        url: pre.url,
        title: (f.name || "screenshot").replace(/\.[^.]+$/, ""),
        source: "upload"
      });
    });
    /** Vision description for each new screenshot, then written onto the story as a source block the writers read. */
    _defineProperty(this, "describeAndNote", async (cid, assets, label) => {
      if (!assets.length) return 0;
      await safe(svc(`/content/assets/index?max=${Math.min(40, assets.length + 4)}`).postAsync({}));
      let n = 0;
      for (const a of assets) {
        const id = a && (a.id || a.Id);
        if (!id) continue;
        const fresh = await safe(svc(`/content/assets/${String(id)}`).getAsync());
        const desc = fresh && (fresh.description || fresh.altText);
        const body = `${label}${a.title ? ` · ${a.title}` : ""}\n${desc || "(no description yet: Describe it on the piece page)"}`;
        await safe(svc(`/content/containers/${cid}/blocks`).postAsync({
          kind: "screenshot_note",
          body,
          assetRef: a.url
        }));
        // alt text straight from the description (first sentence, 125 chars): no extra agent run; rewrite it on the asset any time
        if (desc && !(fresh && fresh.altText)) {
          const alt = String(desc).replace(/^\s*(the|this) (image|screenshot|picture) (is|shows|features|displays|depicts) (a |an |the )?/i, "").split(/(?<=[.!?])\s/)[0].trim().slice(0, 125);
          if (alt) await safe(svc(`/content/assets/${String(id)}/alt`).postAsync({
            altText: alt.charAt(0).toUpperCase() + alt.slice(1)
          }));
        }
        if (desc) n++;
      }
      return n;
    });
    // ---- starting material (2026-10-07): catalog products, offer details, documents, existing pieces
    _defineProperty(this, "findProducts", q => {
      this.setState({
        prodQ: q
      });
      clearTimeout(this._pt);
      if (q.trim().length < 2) {
        this.setState({
          prodHits: []
        });
        return;
      }
      this._pt = setTimeout(async () => {
        const hits = await safe(searchProducts(q.trim(), 8));
        if (this._alive && this.state.prodQ === q) this.setState({
          prodHits: hits || []
        });
      }, 250);
    });
    _defineProperty(this, "addProduct", p => {
      if (this.state.products.some(x => x.id === p.id) || this.state.products.length >= 12) return;
      this.setState({
        products: [...this.state.products, p],
        prodQ: "",
        prodHits: []
      });
    });
    _defineProperty(this, "loadLibrary", async () => {
      if (this.state.library) return;
      const all = [];
      for (let skip = 0; skip < 1000; skip += 100) {
        const d = await safe(svc(`/content/containers/last_90_days?$top=100&$skip=${skip}`).getAsync());
        const it = d && d.items || [];
        all.push(...it);
        if (it.length < 100) break;
      }
      if (this._alive) this.setState({
        library: all.filter(c => String(c.status || "").toLowerCase() !== "archived")
      });
    });
    _defineProperty(this, "togglePiece", c => {
      const id = String(c.id);
      const has = this.state.pieces.some(x => String(x.id) === id);
      this.setState({
        pieces: has ? this.state.pieces.filter(x => String(x.id) !== id) : [...this.state.pieces, c].slice(0, 10)
      });
    });
    _defineProperty(this, "setOffer", (k, v) => this.setState({
      offer: {
        ...this.state.offer,
        [k]: v
      }
    }));
    _defineProperty(this, "uploadDoc", async f => {
      const pre = await svc("/content/assets/upload-url").postAsync({
        fileName: f.name,
        contentType: f.type || "application/octet-stream",
        bytes: f.size
      });
      if (!pre || !pre.uploadUrl) throw new Error("Could not prepare the upload.");
      const put = await fetch(pre.uploadUrl, {
        method: "PUT",
        headers: {
          "content-type": pre.contentType || f.type || "application/octet-stream"
        },
        body: f
      });
      if (!put.ok) throw new Error(`Upload failed (${put.status})`);
      return pre.url;
    });
    _defineProperty(this, "create", async () => {
      const {
        title,
        product,
        summary,
        goal,
        goalText,
        capture,
        files
      } = this.state;
      const urls = this.urlList();
      if (!title.trim()) return;
      this.setState({
        busy: "create",
        log: []
      });
      try {
        this.note("Creating the story…");
        const created = await svc("/content/containers").postAsync({
          title: title.trim(),
          topic: product.trim() || this.state.products[0] && this.state.products[0].title || undefined,
          summary: summary.trim() || undefined,
          origin: "manual"
        });
        const cid = String(created && (created.id || created.Id || created.container && (created.container.id || created.container.Id)) || "");
        if (!cid) throw new Error("The story was not created.");
        // the product facts become the first source block, so the planner has them even before any import
        const facts = [product.trim() ? `Product: ${product.trim()}` : "", goal === "other" && goalText.trim() ? `Goal: ${goalText.trim()}` : "", summary.trim()].filter(Boolean).join("\n");
        if (facts) await safe(svc(`/content/containers/${cid}/blocks`).postAsync({
          kind: "text",
          body: facts
        }));
        const o = this.state.offer;
        const offer = [o.dates.trim() ? `Dates: ${o.dates.trim()}` : "", o.price.trim() ? `Price or discount: ${o.price.trim()}` : "", o.code.trim() ? `Code: ${o.code.trim()}` : "", o.link.trim() ? `Send people to: ${o.link.trim()}` : ""].filter(Boolean);
        if (offer.length) await safe(svc(`/content/containers/${cid}/blocks`).postAsync({
          kind: "offer",
          body: `The offer:\n${offer.join("\n")}`
        }));
        if (this.state.products.length) {
          this.note(`Adding ${this.state.products.length} product${this.state.products.length === 1 ? "" : "s"} from the catalog…`);
          const r = await safe(svc(`/content/containers/${cid}/products`).postAsync({
            productIds: this.state.products.map(p => p.id)
          }));
          this.note(r ? `${r.added} product fact sheet${r.added === 1 ? "" : "s"} added.` : "Products could not be added; link them on a piece later.");
        }
        if (this.state.pieces.length) {
          this.note(`Copying ${this.state.pieces.length} existing piece${this.state.pieces.length === 1 ? "" : "s"}…`);
          const body = JSON.stringify({
            containerIds: []
          }).replace("[]", `[${this.state.pieces.map(c => String(c.id)).join(",")}]`);
          const r = await safe(svc(`/content/containers/${cid}/from-pieces`).postAsync(body));
          this.note(r ? `${r.added} piece${r.added === 1 ? "" : "s"} added as reference.` : "Pieces could not be copied.");
        }
        for (const f of this.state.docs) {
          this.note(`Reading ${f.name}…`);
          try {
            const url = await this.uploadDoc(f);
            const r = await svc(`/content/containers/${cid}/documents`).postAsync({
              url,
              fileName: f.name
            });
            this.note(`${f.name}: ${r && r.pages ? `${r.pages} page${r.pages === 1 ? "" : "s"}, ` : ""}${r ? Number(r.chars).toLocaleString() : "?"} characters added${r && r.truncated ? " (long: the first part is used)" : ""}.`);
          } catch (e) {
            this.note(`${f.name}: ${e && e.message || "could not be read"}.`);
          }
        }
        // pages → source blocks
        let imported = 0;
        for (const u of urls) {
          this.note(`Reading ${u}…`);
          const r = await safe(svc("/content/import").postAsync(JSON.stringify({
            url: u,
            readOnly: true
          }).replace(/}$/, `,"containerId":${cid}}`)));
          if (r) imported++;
        }
        // screenshots: uploads first, then captures from the pages
        const shots = [];
        for (let i = 0; i < files.length; i++) {
          this.note(`Uploading screenshot ${i + 1} of ${files.length}…`);
          const a = await safe(this.uploadOne(files[i]));
          if (a && (a.id || a.Id)) {
            await safe(svc(`/content/assets/${String(a.id || a.Id)}/link`).postAsync({
              containerId: cid,
              role: "source"
            }));
            shots.push({
              ...a,
              url: a.url || files[i].url,
              title: a.title
            });
          }
        }
        // pictures and video picked from Assets: link them to the story (Make can use them) and describe them for the writers
        const picked = this.state.media || [];
        for (const a of picked) {
          if (a && a.id) await safe(svc(`/content/assets/${String(a.id)}/link`).postAsync({
            containerId: cid,
            role: "source"
          }));
        }
        if (picked.length) {
          this.note(`Describing ${picked.length} picture${picked.length === 1 ? "" : "s"} from Assets…`);
          await this.describeAndNote(cid, picked.map(a => ({
            ...a,
            url: a.latestUrl || a.url
          })), "Picture");
        }
        if (capture && urls.length) {
          for (const u of urls) {
            this.note(`Capturing ${u}: a full page and its sections…`);
            try {
              const r = await runAgent("content_capture_agent", `Capture ${u}`, {
                url: u,
                maxSections: "8",
                width: "1440"
              });
              const done = await waitAgent(runIdOf(r), 5000, 36, () => this._alive);
              const cand = done.ok ? done.ctx && done.ctx.url ? done.ctx : done.res : null;
              const out = cand && /^https?:\/\//i.test(String(cand.url || "")) && String(cand.url) !== u ? cand : null; // a real capture, not the source echoed back
              const sections = (out && out.sections || []).filter(x => x && /^https?:\/\//i.test(String(x.url || "")));
              const host = u.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
              const list = [{
                url: out && out.url,
                title: `${out && out.title ? out.title : host} · full page`
              }].concat(sections.map((s, k) => ({
                url: s.url,
                title: s.title ? `${s.title}` : `${host} · section ${k + 1}`
              })));
              for (const sc of list) {
                if (!sc.url) continue;
                const a = await safe(svc("/content/assets").postAsync({
                  kind: "image",
                  url: sc.url,
                  title: sc.title,
                  source: "capture"
                }));
                if (a && (a.id || a.Id)) {
                  await safe(svc(`/content/assets/${String(a.id || a.Id)}/link`).postAsync({
                    containerId: cid,
                    role: "source"
                  }));
                  shots.push({
                    ...a,
                    url: sc.url,
                    title: sc.title
                  });
                }
              }
              if (!out) {
                const why = done.run && (done.run.runResult || done.run.RunResult);
                this.note(`Could not capture ${u}${done.timeout ? " (timed out)" : why ? `: ${String(why).slice(0, 140)}` : ""}.`);
              }
            } catch (e) {
              this.note(`Capture of ${u} failed: ${e && e.message || "error"}`);
            }
          }
        }
        if (capture && urls.length) {
          const u = urls[0];
          const host = u.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
          this.note(`Reading the header, nav and footer of ${host} for the landing page…`);
          try {
            const r = await runAgent("content_capture_agent", `Capture the site frame of ${u}`, {
              url: u,
              frame: "true",
              width: "1440"
            });
            const done = await waitAgent(runIdOf(r), 4000, 24, () => this._alive);
            const frameUrl = done.ok && (done.ctx && done.ctx.frameUrl || done.res && done.res.frameUrl || "");
            if (/^https?:\/\//i.test(String(frameUrl))) await safe(svc(`/content/containers/${cid}/blocks`).postAsync({
              kind: "site_frame",
              body: JSON.stringify({
                url: u,
                host,
                frameUrl,
                title: done.ctx && done.ctx.title || "",
                capturedAt: new Date().toISOString()
              })
            }));else this.note(`Could not read the site frame of ${host}: set it on the landing page later.`);
          } catch (e) {
            this.note(`Site frame of ${host} skipped: ${e && e.message || "error"}`);
          }
        }
        if (shots.length) {
          this.note(`Describing ${shots.length} screenshot${shots.length === 1 ? "" : "s"}…`);
          const n = await this.describeAndNote(cid, shots, "Screenshot");
          this.note(`${n} of ${shots.length} described and written onto the story.`);
        }
        toast(`Story ready: ${imported} page${imported === 1 ? "" : "s"} read, ${shots.length} screenshot${shots.length === 1 ? "" : "s"}. Opening the Builder.`);
        if (this.props.onCreated) this.props.onCreated(cid, {
          goal
        });
      } catch (e) {
        toast(e && e.message || "Could not create the story.");
        if (this._alive) this.setState({
          busy: ""
        });
      }
    });
  }
  // Assets › Select › "Use in a new story" (2026-10-09): /Content/build/new?assets=<ids> starts the story with those
  // pictures and videos already in "Pictures and video" (up to 20). Ids stay strings (they exceed 2^53).
  async componentDidMount() {
    let ids = [];
    try {
      ids = String(new URLSearchParams(window.location.search).get("assets") || "").split(",").map(x => x.trim()).filter(x => /^\d+$/.test(x));
    } catch (e) {
      ids = [];
    }
    ids = [...new Set(ids)].slice(0, 20);
    if (!ids.length) return;
    const found = await Promise.all(ids.map(id => safe(svc(`/content/assets/${id}`).getAsync())));
    const media = found.filter(a => a && a.id != null);
    if (this._alive && media.length) this.setState(s => ({
      media: [...(s.media || []), ...media.filter(a => !(s.media || []).some(m => String(m.id) === String(a.id)))]
    }));
  }
  componentWillUnmount() {
    this._alive = false;
  }
  /** Typed page addresses → full URLs (bare domains get https://). */
  normPages(text) {
    return String(text || "").split(/[\n,\s]+/).map(u => u.trim()).filter(Boolean).map(u => /^https?:\/\//i.test(u) ? u : `https://${u}`).filter(u => /^https?:\/\/[^\s/]+\.[^\s]+/i.test(u));
  }
  /** The pages to read: the list, plus anything still typed in the box, up to six. */
  urlList() {
    const out = [];
    [...this.state.pages, ...this.normPages(this.state.pageDraft)].forEach(u => {
      if (!out.includes(u)) out.push(u);
    });
    return out.slice(0, 6);
  }
  render() {
    const {
      onClose
    } = this.props;
    const s = this.state;
    const busy = !!s.busy;
    const urls = this.urlList();
    const canCreate = !!s.title.trim() && !busy;
    const row = (title, hint, action, body) => /*#__PURE__*/React.createElement("div", {
      className: "ns-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ns-rowhead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ns-rowt"
    }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("i", null, hint)), action), body);
    const act = (label, onClick, on) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ns-act" + (on ? " on" : ""),
      onClick: onClick
    }, label);
    const x = (label, onClick) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ns-x",
      "aria-label": label,
      title: label,
      onClick: onClick
    }, "\xD7");
    const libHits = s.library ? s.library.filter(c => !s.pieceQ.trim() || String(c.title || "").toLowerCase().includes(s.pieceQ.trim().toLowerCase())).slice(0, 40) : [];
    return /*#__PURE__*/React.createElement("div", {
      className: "ns-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ns-top"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ns-back",
      "aria-label": "Back to Stories",
      title: "Back to Stories",
      disabled: busy,
      onClick: onClose
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M15 18l-6-6 6-6"
    }))), /*#__PURE__*/React.createElement("span", {
      className: "ns-name"
    }, "New story"), /*#__PURE__*/React.createElement("span", {
      className: "ns-sp"
    }), /*#__PURE__*/React.createElement("span", {
      className: "ns-next"
    }, busy ? s.step : "Next, Plunk plans the pieces. Nothing is written until you say so."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ns-primary",
      disabled: !canCreate,
      title: !s.title.trim() ? "Give the story a name first" : undefined,
      onClick: this.create
    }, busy ? "Creating…" : "Create the story")), busy ? /*#__PURE__*/React.createElement("div", {
      className: "ns-busy"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ns-busyhead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ns-spin",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("b", null, "Setting up ", s.title.trim() || "the story")), /*#__PURE__*/React.createElement("span", {
      className: "ns-busyhint"
    }, "Reading what you gave us. The Builder opens on its own when this is done."), /*#__PURE__*/React.createElement("ul", {
      className: "ns-log"
    }, s.log.map((m, i) => /*#__PURE__*/React.createElement("li", {
      key: i,
      className: i === s.log.length - 1 ? "cur" : ""
    }, m)))) : /*#__PURE__*/React.createElement("div", {
      className: "ns-cols"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ns-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ns-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "ns-title",
      className: "ns-q"
    }, "What is the story called?"), /*#__PURE__*/React.createElement("input", {
      id: "ns-title",
      className: "ns-title",
      value: s.title,
      autoFocus: true,
      placeholder: "e.g. Spring launch",
      onChange: e => this.setState({
        title: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter" && canCreate) this.create();
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "ns-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "ns-about",
      className: "ns-q"
    }, "Tell Plunk about it"), /*#__PURE__*/React.createElement("span", {
      className: "ns-help"
    }, "What it is, who it is for, and what makes it different. A few plain lines is plenty; the writers only use what you give them."), /*#__PURE__*/React.createElement("textarea", {
      id: "ns-about",
      className: "ns-about",
      rows: 5,
      value: s.summary,
      placeholder: "Our spring range is here: lighter fabrics and three new colors. Made for people who want a fresh look without starting over. 15% off for the first two weeks.",
      onChange: e => this.setState({
        summary: e.target.value
      })
    }), /*#__PURE__*/React.createElement("label", {
      className: "ns-subject"
    }, /*#__PURE__*/React.createElement("span", null, "Name of the product, service or offer ", /*#__PURE__*/React.createElement("i", null, "optional")), /*#__PURE__*/React.createElement("input", {
      value: s.product,
      placeholder: "e.g. The Spring Collection",
      onChange: e => this.setState({
        product: e.target.value
      })
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ns-field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ns-q",
      id: "ns-goal"
    }, "What is it for?"), /*#__PURE__*/React.createElement("div", {
      className: "ns-chips",
      role: "radiogroup",
      "aria-labelledby": "ns-goal"
    }, GOALS.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: k,
      role: "radio",
      "aria-checked": s.goal === k,
      className: "ns-chip" + (s.goal === k ? " on" : ""),
      onClick: () => this.setState({
        goal: k
      })
    }, l))), s.goal === "other" && /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.goalText,
      autoFocus: true,
      placeholder: "What should this story achieve?",
      "aria-label": "What should this story achieve?",
      onChange: e => this.setState({
        goalText: e.target.value
      })
    }))), /*#__PURE__*/React.createElement("aside", {
      className: "ns-side",
      "aria-label": "More to work from"
    }, /*#__PURE__*/React.createElement("b", {
      className: "ns-sidet"
    }, "Give the writers more to work from"), /*#__PURE__*/React.createElement("span", {
      className: "ns-sideh"
    }, "Optional. Everything here can be added later on the Brief."), row("Web pages to read", "We read each page and take screenshots of it.", act("Add a page", () => this.setState({
      pageOpen: true
    })), /*#__PURE__*/React.createElement(React.Fragment, null, s.pages.map(u => /*#__PURE__*/React.createElement("div", {
      key: u,
      className: "ns-item"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ns-url",
      title: u
    }, u.replace(/^https?:\/\//i, "")), x("Remove", () => this.setState({
      pages: s.pages.filter(p => p !== u)
    })))), (s.pageOpen || s.pageDraft) && s.pages.length < 6 && /*#__PURE__*/React.createElement("div", {
      className: "ns-addline"
    }, /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.pageDraft,
      autoFocus: true,
      placeholder: "yourstore.com/spring",
      "aria-label": "Page address",
      onChange: e => this.setState({
        pageDraft: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") {
          e.preventDefault();
          this.addPages();
        }
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ns-act",
      disabled: !this.normPages(s.pageDraft).length,
      onClick: this.addPages
    }, "Add")), urls.length > 0 && /*#__PURE__*/React.createElement("label", {
      className: "ns-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: s.capture,
      onChange: () => this.setState({
        capture: !s.capture
      })
    }), /*#__PURE__*/React.createElement("span", null, "Take screenshots of ", urls.length === 1 ? "the page" : `all ${urls.length} pages`, ", each section too. The first page's header and footer are reused on the landing page.")))), row("Products", "Their descriptions, prices and options are used.", act(s.products.length ? "Add more" : "Pick products", () => this.setState({
      prodOpen: true
    })), /*#__PURE__*/React.createElement(React.Fragment, null, s.products.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "ns-tokens"
    }, s.products.map(p => /*#__PURE__*/React.createElement("span", {
      key: p.id,
      className: "ns-token"
    }, p.imageUrl ? /*#__PURE__*/React.createElement("img", {
      src: p.imageUrl,
      alt: ""
    }) : null, /*#__PURE__*/React.createElement("b", null, p.title), x("Remove", () => this.setState({
      products: s.products.filter(y => y.id !== p.id)
    }))))), s.prodOpen && /*#__PURE__*/React.createElement("div", {
      className: "ns-searchwrap"
    }, /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.prodQ,
      autoFocus: true,
      placeholder: "Search products by name or SKU",
      "aria-label": "Search products",
      onChange: e => this.findProducts(e.target.value)
    }), s.prodHits.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "ns-hits"
    }, s.prodHits.map(p => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: p.id,
      onClick: () => this.addProduct(p)
    }, p.imageUrl ? /*#__PURE__*/React.createElement("img", {
      src: p.imageUrl,
      alt: ""
    }) : /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "inventory_2"), /*#__PURE__*/React.createElement("span", null, p.title))))))), row("The offer", "Dates, price or discount, a code, where to send people.", s.offerOpen ? null : act("Add details", () => this.setState({
      offerOpen: true
    })), s.offerOpen && /*#__PURE__*/React.createElement("div", {
      className: "ns-offer"
    }, /*#__PURE__*/React.createElement("label", null, "Dates", /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.offer.dates,
      placeholder: "e.g. Starts May 4, ends May 18",
      onChange: e => this.setOffer("dates", e.target.value)
    })), /*#__PURE__*/React.createElement("label", null, "Price or discount", /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.offer.price,
      placeholder: "e.g. 15% off, or from $49",
      onChange: e => this.setOffer("price", e.target.value)
    })), /*#__PURE__*/React.createElement("label", null, "Code", /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.offer.code,
      placeholder: "e.g. SPRING15",
      onChange: e => this.setOffer("code", e.target.value)
    })), /*#__PURE__*/React.createElement("label", null, "Send people to", /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.offer.link,
      placeholder: "yourstore.com/spring",
      onChange: e => this.setOffer("link", e.target.value)
    })))), /*#__PURE__*/React.createElement("input", {
      type: "file",
      multiple: true,
      accept: ".pdf,.docx,.txt,.md,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain",
      style: {
        display: "none"
      },
      ref: r => {
        this._docs = r;
      },
      onChange: e => {
        const add = Array.from(e.target.files || []);
        this.setState({
          docs: [...s.docs, ...add].slice(0, 6)
        });
        e.target.value = "";
      }
    }), row("Documents", "Spec sheets, press releases, briefs. PDF, Word or text.", act("Upload", () => this._docs && this._docs.click()), s.docs.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "ns-tokens"
    }, s.docs.map((f, i) => /*#__PURE__*/React.createElement("span", {
      key: i,
      className: "ns-token"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "description"), /*#__PURE__*/React.createElement("b", null, f.name), x("Remove", () => this.setState({
      docs: s.docs.filter((_, k) => k !== i)
    })))))), row("Pictures and video", "From Assets, or upload new ones. The writers see what is in them, and the pieces can use them.", act("Pick from Assets", () => this.setState({
      mediaPick: (s.media || []).map(a => String(a.id))
    })), s.media.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "ns-shots"
    }, s.media.map(a => /*#__PURE__*/React.createElement("span", {
      key: String(a.id),
      className: "ns-shot",
      title: a.title || ""
    }, (a.kind === "video" ? a.posterUrl : a.latestUrl || a.url) ? /*#__PURE__*/React.createElement("img", {
      src: a.kind === "video" ? a.posterUrl : a.latestUrl || a.url,
      alt: ""
    }) : null, x("Remove", () => this.setState({
      media: s.media.filter(m => String(m.id) !== String(a.id))
    })))))), row("Earlier pieces", "Posts, emails or pages to build on. Their text is copied in.", s.library === null ? act("Pick from Library", this.loadLibrary) : null, s.library !== null && /*#__PURE__*/React.createElement("div", {
      className: "ns-pieces"
    }, /*#__PURE__*/React.createElement("input", {
      className: "ns-input",
      value: s.pieceQ,
      placeholder: "Search your pieces",
      "aria-label": "Search your pieces",
      onChange: e => this.setState({
        pieceQ: e.target.value
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "ns-piecelist"
    }, !s.library.length ? /*#__PURE__*/React.createElement("span", {
      className: "ns-none"
    }, "Nothing in the Library yet.") : !libHits.length ? /*#__PURE__*/React.createElement("span", {
      className: "ns-none"
    }, "No pieces match.") : libHits.map(c => {
      const on = s.pieces.some(y => String(y.id) === String(c.id));
      return /*#__PURE__*/React.createElement("label", {
        key: String(c.id),
        className: "ns-piece" + (on ? " on" : "")
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: on,
        onChange: () => this.togglePiece(c)
      }), /*#__PURE__*/React.createElement("span", null, c.title || "Untitled"));
    })), s.pieces.length > 0 && /*#__PURE__*/React.createElement("span", {
      className: "ns-picked"
    }, s.pieces.length, " picked"))))), Array.isArray(s.mediaPick) && /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-back",
      onMouseDown: e => {
        if (e.target === e.currentTarget) this.setState({
          mediaPick: null
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-pick",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "ns-pick-t"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-h"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      id: "ns-pick-t"
    }, "Pictures and video for this story"), /*#__PURE__*/React.createElement("span", null, "Pick from Assets or upload new ones.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-x",
      "aria-label": "Close",
      onClick: () => this.setState({
        mediaPick: null
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "close"))), /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-b"
    }, /*#__PURE__*/React.createElement(AssetPicker, {
      accept: "any",
      only: ["product", "image", "render", "clip", "recording"],
      max: 20,
      picks: s.mediaPick,
      onAssets: list => this.setState({
        mediaAll: list || []
      }),
      onChange: ids => this.setState({
        mediaPick: ids
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-f"
    }, /*#__PURE__*/React.createElement("span", null, s.mediaPick.length ? `${s.mediaPick.length} picked` : "Click to pick, click again to drop."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-btn",
      onClick: () => this.setState({
        mediaPick: null
      })
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-primary",
      onClick: () => {
        const byId = new Map([...(s.mediaAll || []), ...(s.media || [])].map(a => [String(a.id), a]));
        this.setState({
          media: s.mediaPick.map(id => byId.get(String(id))).filter(Boolean),
          mediaPick: null
        });
      }
    }, s.mediaPick.length ? `Use ${s.mediaPick.length}` : "Use none")))));
  }
}
export default CreateStorySheet;